import React from "react";
import { useNavigate } from "react-router";

const UserRemoved = ({ setUserGotRemovedPopUp }) => {
  const navigate = useNavigate();
  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-1000">
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[40dvw] bg-white rounded-lg p-6"
      >
        <p>You have been removed from this group. Kindly exit.</p>
        <div className="flex justify-end items-center">
          <button onClick={() => navigate("/workspaces")}>Exit</button>
        </div>
      </div>
    </div>
  );
};

export default UserRemoved;
